import { ChangeDetectionStrategy, Component } from '@angular/core';
import { C3Service } from '../../c3.service';
import { PaneChild } from '../pane/pane.component';

@Component({
    selector: 'app-results-config',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './results-config.component.html',
    styleUrls: ['./results-config.component.css'],
    standalone: false
})
export class ResultsConfigComponent extends PaneChild {
  private _c3Service: C3Service;
  private _opened = false;

  public get scalarResults() {
    return this._c3Service.scalarResults;
  }
  public get vectorResults() {
    return this._c3Service.vectorResults;
  }
  public get modelScalarId() {
    if (this._c3Service._model['0'].modelSpec) {
      return this._c3Service._model['0'].modelSpec.fringesResultId;
    }
    return 0;
  }

  public get modelVectorId() {
    if (this._c3Service._model['0'].modelSpec) {
      return this._c3Service._model['0'].modelSpec.vectorResultIdArray.length > 0
        ? this._c3Service._model['0'].modelSpec.vectorResultIdArray[0]
        : -1;
    }
    return -1;
  }

  public get modelSpec() {
    return this._c3Service._model['0'].modelSpec;
  }

  public constructor(c3Service: C3Service) {
    super();
    this._c3Service = c3Service;
  }

  public modelScalarChanged(event: Event, id: number) {
    if ((<any>event.target).checked) {
      this.modelSpec.fringesResultId = id;
    } else if (id === this.modelSpec.fringesResultId) {
      this.modelSpec.fringesResultId = -1;
    }
  }

  public modelVectorChanged(event: Event, id: number) {
    if ((event.target as any).checked) {
      this.modelSpec.vectorResultIdArray = [id];
    } else if (id === this.modelVectorId) {
      this.modelSpec.vectorResultIdArray = [];
    }
  }

  public tabButtonClicked(tabName: string) {
    const tabContents = document.getElementsByClassName('tab-content');
    for (let i = 0; i < tabContents.length; i++) {
      (<any>tabContents[i]).style.display = 'none';
    }

    const tabButtons = document.getElementsByClassName('tab-button');
    for (let i = 0; i < tabButtons.length; i++) {
      tabButtons[i].className = tabButtons[i].className.replace(' active', '');
    }

    if (document !== null) {
      const _tabName = document.getElementById(tabName);
      const _tabNameBtn = document.getElementById(tabName + '-button');

      if (_tabName) {
        _tabName.style.display = 'block';
      }

      if (_tabNameBtn) {
        _tabNameBtn.className += ' active';
      }
    }
  }

  protected override onVisibleChanged(visible: boolean) {
    if (visible && !this._opened) {
      setTimeout(() => this.tabButtonClicked('scalar'), 0);
      this._opened = true;
    }
  }
}
